module.exports = __webpack_public_path__ + "img/feature-inventory.cc3e0372.png";